<template>
  <div id="editorial-borad-pdf">
    <ipub-model
      :title="title"
      width="920px"
      :visable="isVisable"
      @confirm="confirm"
      confirmText="Generate"
      @cancel="cancel"
    >
      <ipub-form
        ref="add-pdf-form"
        :model="params"
        autocomplete="off"
        :rules="rules"
      >
        <div v-show="edit">
          <div v-show="['eb-c', 'rb-c', 'ge-c', 'rc-c'].includes(type)">
            <ipub-row :gutter="20">
              <ipub-col :span="4">
                <ipub-form-item prop="firstName" label="First Name">
                  <ipub-input
                    placeholder="First Name"
                    v-model.trim="params.firstName"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="lastName" label="Last Name">
                  <ipub-input
                    placeholder="Last Name"
                    v-model.trim="params.lastName"
                  />
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="4">
                <ipub-form-item prop="createTime" label="Date">
                  <ipub-date-picker
                    placeholder="Date"
                    v-model="params.createTime"
                  />
                </ipub-form-item>
              </ipub-col>
            </ipub-row>
          </div>
          <div v-show="['eb-b', 'rb-b', 'ge-b'].includes(type)">
            <ipub-row :gutter="20">
              <ipub-col :span="9">
                <ipub-row :gutter="20">
                  <ipub-col :span="6">
                    <ipub-form-item prop="firstName" label="First Name">
                      <ipub-input
                        placeholder="First Name"
                        v-model.trim="params.firstName"
                      />
                    </ipub-form-item>
                  </ipub-col>
                  <ipub-col :span="6">
                    <ipub-form-item prop="lastName" label="Last Name">
                      <ipub-input
                        placeholder="Last Name"
                        v-model.trim="params.lastName"
                      />
                    </ipub-form-item>
                  </ipub-col>
                </ipub-row>

                <ipub-form-item
                  prop="degreesIdList"
                  label="Degree / Credential"
                >
                  <ipub-select
                    placeholder="Degree / Credential"
                    :tree="true"
                    search
                    mode="multiple"
                    @search="getDegrees"
                    v-model="params.degreesIdList"
                  >
                    <ipub-select-option
                      v-for="item in degreesList"
                      :key="item.id"
                      :value="item.name"
                      >{{ item.name }}({{ item.otherName }})
                    </ipub-select-option>
                  </ipub-select>
                </ipub-form-item>
              </ipub-col>
              <ipub-col :span="3">
                <ipub-form-item prop="icon">
                  <div class="upload-content right-option">
                    <div class="upload-content-img">
                      <ipub-upload-cropper
                        @change="
                          (e) => {
                            handleUpload('icon', e)
                          }
                        "
                        :canWidth="105"
                        :canHeight="130"
                        :scales="2"
                        :imgUrl="
                          params.icon
                            ? domain + '/' + params.icon
                            : domain + '/imageFile/icon.svg'
                        "
                      />
                    </div>
                  </div>
                </ipub-form-item>
              </ipub-col>
            </ipub-row>

            <ipub-form-item prop="affiliation" label="Affiliations">
              <div
                v-for="(item, index) in params.affiliations"
                class="mar-b-10"
                :key="'params.affiliations' + index"
              >
                <ipub-input
                  placeholder="Affiliations"
                  suffixIcon="iconClose"
                  @blur="getMore('affiliation')"
                  @iconClick="delMore('affiliations', index)"
                  v-model.trim="params.affiliations[index]"
                />
              </div>
              <ipub-button
                type="primary"
                icon="iconAdd"
                @click="addMore('affiliations')"
                style="width: 240px"
                plain
                >Add Affilications
              </ipub-button>
            </ipub-form-item>
          </div>
          <ipub-form-item
            prop="scale"
            label="File Quality (The file size will increase with the file quality, please select the file quality that meets your needs)"
          >
            <ipub-select placeholder="File Quality" v-model="scale">
              <ipub-select-option
                v-for="item in 4"
                :key="'scale' + item"
                :value="item"
                >{{ item }} Level
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </div>

        <ipub-form-item prop="preview" label="Preview">
          <div class="showPDFDialog">
            <div
              id="showPDFDialog"
              :style="
                ['eb-b', 'rb-b', 'ge-b'].includes(type) ? 'height:1226px' : ''
              "
            >
              <template v-if="['eb-c', 'rb-c', 'ge-c', 'rc-c'].includes(type)">
                <div
                  class="pdf-content"
                  :style="`background-image:url(${cbg[journalDetail.name]})`"
                >
                  <div class="pdf-content-icon">
                    <div class="tl">
                      <img :src="jLogo[journalDetail.name]" alt="" />
                    </div>
                    <div class="tr">
                      <img :src="logo" alt="" />
                    </div>
                  </div>
                  <div class="pdf-content-title mar-b-20">
                    <template v-if="type === 'eb-c'"
                      >Certificate of Appointment</template
                    >
                    <template v-else-if="type === 'rb-c' || type === 'rc-c'"
                      >Certificate of Reviewing</template
                    >
                    <template v-else-if="type === 'ge-c'"
                      >Certificate of Appointment</template
                    >
                  </div>
                  <div class="tc mar-b-20">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      :class="[
                        'svg-logo',
                        journalDetail.name ? journalDetail.name : '',
                      ]"
                      width="128"
                      height="40"
                      viewBox="0 0 80.447 29.948"
                    >
                      <g
                        id="Group_137"
                        data-name="Group 137"
                        transform="translate(-551.654 -336.345)"
                      >
                        <path
                          id="Path_567"
                          data-name="Path 567"
                          d="M575.232,366.293l.9-.158c.3-.055.669-.112,1.108-.2s.949-.184,1.526-.308l.913-.208c.322-.068.657-.157,1.009-.249s.721-.182,1.1-.3l.583-.173.3-.09.3-.1a33,33,0,0,0,5.435-2.366c1.97-1.052,4.1-2.336,6.47-3.675.293-.172.6-.326.911-.492l.466-.247c.154-.085.319-.153.479-.232.323-.15.648-.306.98-.457l1.018-.422c.341-.15.7-.267,1.051-.4s.712-.266,1.082-.377l1.111-.356,1.145-.318c.383-.114.778-.2,1.173-.292l.6-.141c.2-.049.4-.082.6-.124.406-.078.814-.166,1.228-.237l1.256-.2a40.244,40.244,0,0,1,5.272-.392,29.02,29.02,0,0,1,5.588.477,11.152,11.152,0,0,1,1.429.335,8.161,8.161,0,0,1,1.4.556,4.553,4.553,0,0,1,1.259.932,2.769,2.769,0,0,1,.458.689,2.311,2.311,0,0,1,.2.826,2.605,2.605,0,0,1-.116.84,3.448,3.448,0,0,1-.354.748,5.4,5.4,0,0,1-1.068,1.2,9.923,9.923,0,0,1-1.293.931l-.345.2c-.115.067-.233.124-.349.187q-.353.183-.705.369a21.071,21.071,0,0,1-3.009,1.173,19.961,19.961,0,0,1-3.234.664,24.766,24.766,0,0,1-3.356.172c-1.13-.017-2.265-.1-3.4-.211-.285-.025-.569-.059-.854-.09s-.571-.068-.858-.107l-.861-.116-.433-.059-.43-.074-.865-.15-.433-.076c-.145-.024-.288-.059-.432-.088l-.865-.183c-.289-.062-.58-.119-.867-.2a61.093,61.093,0,0,1-13.714-5.178c-2.244-1.148-4.462-2.42-6.657-3.789-.274-.172-.55-.34-.825-.516s-.549-.356-.82-.539c-.543-.364-1.078-.738-1.613-1.115-1.068-.752-2.133-1.515-3.218-2.255s-2.188-1.463-3.33-2.126a27.478,27.478,0,0,0-3.541-1.774l-.46-.184-.466-.166-.233-.083-.236-.073-.472-.145-.478-.122c-.08-.02-.16-.042-.24-.061l-.241-.048c-.161-.031-.322-.067-.483-.1l-.487-.068a9.819,9.819,0,0,0-1.953-.062l-.244.015c-.081,0-.161.021-.242.03l-.483.067-.476.105c-.079.019-.159.031-.237.055l-.233.072c-.155.051-.313.09-.465.149l-.453.183a8.566,8.566,0,0,0-.883.43,8.042,8.042,0,0,0-1.569,1.153,6.763,6.763,0,0,0-.649.715,6.253,6.253,0,0,0-.535.8,6.337,6.337,0,0,0-.4.871,5.9,5.9,0,0,0-.246.924,6.248,6.248,0,0,0,.557,3.782,8.4,8.4,0,0,0,.477.872c.093.139.183.279.281.417l.3.413a13.192,13.192,0,0,0,1.376,1.529,13.944,13.944,0,0,0,3.4,2.372,17.069,17.069,0,0,0,3.983,1.39,22.034,22.034,0,0,0,4.263.493l.541.005.542-.006.542-.018.544-.037.544-.037c.181-.015.363-.019.543-.045l1.086-.129a33.475,33.475,0,0,0,4.3-.9,40.434,40.434,0,0,0,4.184-1.472l1.026-.44c.34-.153.677-.313,1.016-.47s.674-.326,1.01-.491l.5-.25c.168-.084.333-.173.5-.26,1.333-.691,2.646-1.439,3.952-2.212,2.613-1.545,5.161-3.185,7.741-4.757,1.291-.785,2.589-1.554,3.9-2.291s2.652-1.428,4.008-2.075,2.746-1.22,4.152-1.733l1.062-.367c.354-.119.715-.22,1.071-.331.18-.054.356-.11.537-.161l.554-.143c.184-.047.371-.082.556-.124s.371-.075.558-.106c.372-.071.746-.116,1.119-.167s.748-.08,1.123-.1.748-.036,1.121-.048.746-.006,1.118.009.743.033,1.114.053.739.059,1.106.106.734.1,1.1.147.728.119,1.089.2c.723.142,1.437.32,2.142.527a21.119,21.119,0,0,1,2.08.722,17.316,17.316,0,0,1,1.99.944,13.918,13.918,0,0,1,1.847,1.217,9.21,9.21,0,0,1,1.59,1.574c.113.152.221.308.332.461s.2.335.294.508l.123.272.06.136c.017.047.032.1.048.143l.091.288c.026.1.041.2.061.3a3.717,3.717,0,0,1,.064.606c0,.1-.007.2-.011.3l-.009.151c0,.051-.015.1-.022.15l-.052.3c-.024.1-.053.192-.08.288l-.041.143-.054.137-.109.274a6.8,6.8,0,0,1-1.3,1.838,11.783,11.783,0,0,1-1.664,1.388,16.963,16.963,0,0,1-1.82,1.1,18.5,18.5,0,0,1-1.92.871c-.327.129-.661.244-1,.35s-.69.194-1.027.267-.684.137-1.026.2c-.171.027-.343.05-.515.075l-.257.037-.258.028c-.687.085-1.375.116-2.059.139a30.875,30.875,0,0,1-4.059-.194c-1.335-.148-2.649-.361-3.942-.619s-2.568-.553-3.824-.872c-2.513-.635-4.958-1.356-7.372-2.009-.6-.162-1.213-.34-1.815-.508-.3-.086-.6-.184-.9-.276s-.6-.183-.892-.282l-.882-.3-.44-.151-.434-.163-.867-.325c-.287-.111-.57-.23-.854-.345a64.773,64.773,0,0,1-6.5-3.13c-2.075-1.124-4.073-2.286-6.049-3.4q-.739-.418-1.477-.825c-.244-.135-.491-.276-.732-.4-.119-.064-.238-.128-.361-.187s-.244-.12-.367-.177a21.955,21.955,0,0,0-3.05-1.125,21.229,21.229,0,0,0-3.119-.664c-.521-.067-1.041-.113-1.557-.128a10.465,10.465,0,0,0-1.528.068,6.464,6.464,0,0,0-1.446.334,3.88,3.88,0,0,0-1.227.708,2.787,2.787,0,0,0-.254.246l-.122.132a1.362,1.362,0,0,0-.117.136c-.072.1-.15.185-.217.282s-.13.2-.191.3a3.287,3.287,0,0,0-.44,1.293,3.329,3.329,0,0,0,.13,1.344,4.642,4.642,0,0,0,.6,1.237,8,8,0,0,0,1.958,1.958,11.212,11.212,0,0,0,2.412,1.306,10.459,10.459,0,0,0,1.284.419l.327.088c.108.028.218.05.327.076.219.05.436.1.655.138a18.9,18.9,0,0,0,5.172.248,25.221,25.221,0,0,0,4.8-.913,38.979,38.979,0,0,0,4.317-1.529c1.359-.568,2.643-1.169,3.862-1.769,2.438-1.2,4.623-2.393,6.61-3.421s3.775-1.906,5.367-2.572a27.342,27.342,0,0,1,4.132-1.4,15.459,15.459,0,0,1,2.65-.421l.4-.023.286,0,.231,0-.23.007-.286.008-.4.028a15.631,15.631,0,0,0-2.638.458,27.479,27.479,0,0,0-4.1,1.451c-1.578.686-3.351,1.582-5.322,2.637s-4.142,2.268-6.572,3.5c-1.216.617-2.5,1.236-3.86,1.822a39.4,39.4,0,0,1-4.338,1.593,25.672,25.672,0,0,1-4.871.979,19.385,19.385,0,0,1-5.3-.2c-.226-.037-.45-.086-.675-.135-.113-.026-.226-.047-.338-.076l-.336-.086a11.231,11.231,0,0,1-1.344-.424,11.769,11.769,0,0,1-2.542-1.345,8.55,8.55,0,0,1-2.117-2.081,5.215,5.215,0,0,1-.686-1.384,3.805,3.805,0,0,1,.338-3.112c.068-.116.143-.228.216-.342s.161-.215.242-.322a1.77,1.77,0,0,1,.13-.154l.135-.149a3.34,3.34,0,0,1,.293-.289,4.525,4.525,0,0,1,1.42-.84,7.149,7.149,0,0,1,1.59-.385,11.363,11.363,0,0,1,1.628-.087,16.2,16.2,0,0,1,1.629.12,21.865,21.865,0,0,1,3.23.658,22.53,22.53,0,0,1,3.165,1.139c.13.058.259.118.388.182s.257.128.384.2c.253.134.495.269.743.4q.743.4,1.488.816c1.989,1.1,4,2.242,6.064,3.342a64.569,64.569,0,0,0,6.443,3.045c.28.11.559.226.842.333l.854.314.428.157.434.145.869.292c.291.1.586.181.88.272s.587.183.885.266c.6.162,1.189.331,1.8.49,2.433.643,4.875,1.346,7.369,1.96,1.246.309,2.505.594,3.778.839s2.56.448,3.859.585a29.991,29.991,0,0,0,3.922.168c.655-.025,1.312-.059,1.964-.142l.245-.028.244-.036.487-.074c.322-.063.647-.115.966-.2s.632-.149.943-.249.62-.207.926-.33a17.594,17.594,0,0,0,1.806-.829,16.02,16.02,0,0,0,1.7-1.036,10.693,10.693,0,0,0,1.5-1.261,5.713,5.713,0,0,0,1.083-1.53,2.859,2.859,0,0,0,.227-1.707c-.015-.07-.024-.142-.043-.212l-.069-.21c-.011-.035-.021-.07-.034-.105l-.047-.1-.092-.2c-.072-.134-.153-.264-.232-.4-.095-.129-.186-.261-.283-.39a8.119,8.119,0,0,0-1.405-1.378,12.841,12.841,0,0,0-1.7-1.109,16.243,16.243,0,0,0-1.867-.878,20.224,20.224,0,0,0-1.974-.678c-.672-.2-1.354-.363-2.045-.5-.345-.073-.694-.125-1.041-.185s-.7-.1-1.051-.138-.705-.067-1.058-.1-.707-.045-1.062-.049-.71-.007-1.065-.005-.71.018-1.064.048-.707.06-1.061.1-.7.092-1.052.159c-.174.03-.349.061-.522.1s-.347.072-.518.116l-.513.134c-.172.049-.345.105-.518.157-.345.108-.694.206-1.038.322l-1.029.358q-2.048.753-4.043,1.7c-1.326.635-2.636,1.32-3.934,2.043s-2.58,1.491-3.862,2.272c-2.563,1.564-5.114,3.207-7.753,4.768-1.319.781-2.65,1.539-4.01,2.243-.17.088-.338.179-.509.265l-.514.255c-.344.169-.683.344-1.032.5s-.693.324-1.042.481l-1.054.451a41.658,41.658,0,0,1-4.32,1.515,34.6,34.6,0,0,1-4.466.932l-1.13.132c-.187.027-.377.031-.566.046l-.566.038-.566.038-.568.017-.567.006-.568-.007a23.14,23.14,0,0,1-4.493-.53,18.206,18.206,0,0,1-4.255-1.5,15.112,15.112,0,0,1-3.671-2.581,14.477,14.477,0,0,1-1.489-1.664l-.329-.449c-.107-.152-.21-.312-.314-.469a9.422,9.422,0,0,1-.541-1,7.358,7.358,0,0,1-.632-4.457,7.113,7.113,0,0,1,.3-1.1,7.3,7.3,0,0,1,.479-1.035,7.141,7.141,0,0,1,.633-.939,7.591,7.591,0,0,1,.76-.831,9.118,9.118,0,0,1,1.8-1.31,9.417,9.417,0,0,1,.991-.479l.513-.2c.172-.065.351-.111.526-.167l.264-.079c.088-.026.179-.041.268-.062l.538-.116.544-.073c.09-.011.18-.028.271-.033l.273-.015a10.832,10.832,0,0,1,2.163.076l.531.078c.176.031.349.07.524.105l.261.054c.086.02.171.044.257.065l.513.134.5.158.252.078.246.089.493.178.483.2a28.7,28.7,0,0,1,3.667,1.858c1.168.687,2.287,1.429,3.38,2.183s2.158,1.526,3.218,2.281c.53.378,1.058.751,1.589,1.112.265.182.531.357.8.531s.542.344.812.515c2.167,1.369,4.354,2.641,6.564,3.79a60.445,60.445,0,0,0,13.48,5.2c.282.077.567.135.851.2l.85.187c.142.03.282.065.424.09l.426.077.849.155.423.076.424.061.847.121c.281.041.562.082.845.112s.563.069.844.1c1.123.12,2.235.209,3.337.234a23.91,23.91,0,0,0,3.257-.14,19.246,19.246,0,0,0,3.124-.613,20.37,20.37,0,0,0,2.913-1.107l.686-.351c.113-.059.229-.114.339-.177l.329-.188a9.225,9.225,0,0,0,1.215-.857,4.751,4.751,0,0,0,.957-1.054,2.808,2.808,0,0,0,.3-.606,2.028,2.028,0,0,0,.095-.632,1.717,1.717,0,0,0-.144-.609,2.17,2.17,0,0,0-.354-.542,3.967,3.967,0,0,0-1.087-.815,7.634,7.634,0,0,0-1.3-.528,10.605,10.605,0,0,0-1.367-.334,28.637,28.637,0,0,0-5.484-.524,40.089,40.089,0,0,0-5.211.334l-1.245.182c-.411.066-.815.149-1.218.221-.2.04-.4.07-.6.116l-.591.134c-.392.092-.785.168-1.166.276l-1.137.3-1.106.339c-.367.107-.721.238-1.075.362s-.707.24-1.046.384l-1.013.407c-.33.145-.653.3-.975.441-.16.076-.323.141-.477.224l-.464.239c-.306.161-.613.308-.909.478-2.384,1.309-4.529,2.567-6.52,3.6a33.023,33.023,0,0,1-5.489,2.306l-.3.1-.3.087-.587.166c-.381.114-.754.2-1.107.286s-.69.172-1.014.236l-.917.2c-.578.116-1.091.2-1.531.288s-.813.133-1.111.184Z"
                          fill="currentColor"
                        />
                        <path
                          id="Path_568"
                          data-name="Path 568"
                          d="M590.774,336.368c.2-.075.449.035.683.3a2.39,2.39,0,0,1,.512,1.215,4.142,4.142,0,0,1-.033,1.171,5.281,5.281,0,0,1-.464,1.465,5.142,5.142,0,0,1-.706,1.09c-.219.255-.387.393-.428.37-.083-.044.188-.838.257-1.712a6.18,6.18,0,0,0-.017-1.267c-.007-.1-.024-.188-.037-.275s-.024-.169-.04-.246-.025-.15-.036-.212-.023-.123-.03-.173a3.983,3.983,0,0,1-.022-1.1C590.459,336.685,590.572,336.444,590.774,336.368Z"
                          fill="currentColor"
                        />
                        <path
                          id="Path_569"
                          data-name="Path 569"
                          d="M586.621,339.606a.709.709,0,0,1,.3.1,1.141,1.141,0,0,1,.255.21,1.77,1.77,0,0,1,.375.683c.044.139.086.378.155.651a4.261,4.261,0,0,0,.284.833,1.158,1.158,0,0,0,.448.54c.173.1.347.095.364.145.007.02-.018.058-.079.111a.737.737,0,0,1-.125.077.842.842,0,0,1-.191.06,1.111,1.111,0,0,1-.531-.037,1.968,1.968,0,0,1-.553-.278,3.668,3.668,0,0,1-1.253-1.653,1.555,1.555,0,0,1,.016-1.033.761.761,0,0,1,.232-.321A.438.438,0,0,1,586.621,339.606Z"
                          fill="currentColor"
                        />
                        <path
                          id="Path_570"
                          data-name="Path 570"
                          d="M594.75,340.47a.581.581,0,0,1,.52.362,1.136,1.136,0,0,1-.015.916,2.038,2.038,0,0,1-.473.644,2.789,2.789,0,0,1-.859.556,2.348,2.348,0,0,1-.83.187,1.046,1.046,0,0,1-.265-.019c-.065-.014-.1-.033-.11-.056-.027-.085.387-.4.654-.833a2.994,2.994,0,0,0,.313-.63c.067-.194.109-.351.143-.443a1.187,1.187,0,0,1,.356-.458A.909.909,0,0,1,594.75,340.47Z"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="pdf-content-date">
                    <span
                      v-for="i in 3"
                      :key="'svg1-' + i"
                      style="padding: 0 8px"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        :class="[
                          'svg-logo',
                          journalDetail.name ? journalDetail.name : '',
                        ]"
                        width="20"
                        height="20"
                        viewBox="0 0 11.998 11.998"
                      >
                        <rect
                          id="Rectangle_6"
                          data-name="Rectangle 6"
                          width="8.484"
                          height="8.484"
                          transform="matrix(0.707, -0.707, 0.707, 0.707, 0, 5.999)"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    <span style="padding: 0 60px"
                      >Awarded
                      {{ $moment(params.createTime).format('DD MMMM YYYY') }}
                      to</span
                    >
                    <span
                      v-for="i in 3"
                      :key="'svg2-' + i"
                      style="padding: 0 8px"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        :class="[
                          'svg-logo',
                          journalDetail.name ? journalDetail.name : '',
                        ]"
                        width="20"
                        height="20"
                        viewBox="0 0 11.998 11.998"
                      >
                        <rect
                          id="Rectangle_6"
                          data-name="Rectangle 6"
                          width="8.484"
                          height="8.484"
                          transform="matrix(0.707, -0.707, 0.707, 0.707, 0, 5.999)"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </div>
                  <div class="pdf-content-name">
                    {{ params.firstName }} {{ params.lastName }}
                  </div>
                  <div class="pdf-content-journal">
                    <div>
                      <template v-if="type === 'eb-c'"
                        >For joining as
                        {{ editorialBoard[params.identityCode] }} of
                      </template>
                      <template v-if="type === 'rb-c'"
                        >For joining as Reviewer Board Member of</template
                      >
                      <template v-else-if="type === 'rc-c'"
                        >In recognition of the review contributed to</template
                      >
                      <template v-else-if="type === 'ge-c'"
                        >For joining as Guest Editor of</template
                      >
                    </div>
                    <div style="font-size: 56px" class="fw-bd">
                      <i>{{ journalDetail.fullName }}</i>
                    </div>
                    <div>
                      (
                      <template v-if="journalDetail.eissn"
                        >Electronic ISSN: {{ journalDetail.eissn }}</template
                      >
                      <template
                        v-if="journalDetail.issn && journalDetail.eissn"
                      >
                        |</template
                      >
                      <template v-if="journalDetail.issn"
                        >Print ISSN: {{ journalDetail.issn }}</template
                      >
                      )
                    </div>
                    <template v-if="type === 'ge-c'">
                      <div><strong>Special Issue</strong></div>
                      <div v-html="params.specialTitle"></div>
                    </template>
                  </div>
                  <div class="pdf-content-num">
                    No. {{ params.certificateCode }}
                  </div>
                  <div class="pdf-content-chief">
                    <img
                      :src="sign[journalDetail.name]"
                      v-if="sign[journalDetail.name]"
                      alt=""
                    />
                    <div>
                      <div v-html="chief[journalDetail.name]"></div>
                      Editor-in-Chief
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="['eb-b', 'rb-b', 'ge-b'].includes(type)">
                <div
                  class="pdf-content"
                  :style="`height:1226px;background-image:url(${
                    bbg[journalDetail.name]
                  })`"
                >
                  <div class="pdf-content-icon">
                    <div class="tl">
                      <img :src="jLogo[journalDetail.name]" alt="" />
                    </div>
                    <div class="tr" style="font-size: 26px">
                      <div>an Open Access journal by IMR Press</div>
                      <div style="display: inline-block">
                        <div class="pdf-content-icon-r">
                          <div
                            v-if="
                              journalDetail.databaseInclusion &&
                              journalDetail.databaseInclusion.includes(
                                'Clarivate'
                              )
                            "
                            :style="`border-color:${journalDetail.mainColor}`"
                          >
                            <div>
                              IMPACT<br />
                              FACTOR
                            </div>
                            <div :style="`color:${journalDetail.mainColor}`">
                              <strong>{{ journalDetail.impactFactor }}</strong>
                            </div>
                          </div>
                          <div
                            v-if="
                              journalDetail.databaseInclusion &&
                              journalDetail.databaseInclusion.includes('Scopus')
                            "
                            :style="`border-color:${journalDetail.mainColor}`"
                          >
                            <div>Citescore</div>
                            <div :style="`color:${journalDetail.mainColor}`">
                              <strong>{{ journalDetail.citationScore }}</strong>
                            </div>
                            <div>Scopus</div>
                          </div>
                          <div
                            v-if="
                              journalDetail.databaseInclusion &&
                              journalDetail.databaseInclusion.includes('PubMed')
                            "
                            :style="`border-color:${journalDetail.mainColor}`"
                          >
                            <div>Covered in</div>
                            <div><img :src="pubmed" alt="" /></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pdf-content-editor">
                    <div
                      v-if="params.avatar"
                      class="pdf-content-editor-avatar"
                      :style="`border-color:${journalDetail.mainColor}`"
                    >
                      <img :src="params.avatar" alt="" />
                    </div>
                    <div
                      class="pdf-content-editor-detail"
                      :style="
                        params.avatar ? 'width: 1100px;' : 'width: 1500px'
                      "
                    >
                      <div
                        style="
                          font-size: 60px;
                          margin-bottom: 40px;
                          color: #415465;
                        "
                      >
                        A warm welcome to <br />
                        our new
                        <template v-if="type === 'eb-b'">{{
                          editorialBoard[params.identityCode]
                        }}</template>
                        <template v-else-if="type === 'rb-b'"
                          >Reviewer Board Member</template
                        >
                        <template v-else-if="type === 'ge-b'"
                          >Guest Editor</template
                        >
                      </div>
                      <div
                        class="ipub-h1"
                        style="
                          font-size: 90px;
                          margin-bottom: 20px;
                          line-height: 94px;
                        "
                      >
                        {{ params.firstName }} {{ params.lastName }}
                        <template
                          v-if="
                            params.degreesIdList && params.degreesIdList.length
                          "
                          >,
                          {{ params.degreesIdList.join(', ') }}
                        </template>
                      </div>
                      <div style="font-size: 44px">
                        <div
                          v-for="(item, index) in params.affiliations"
                          :key="'affiliations' + index"
                        >
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pdf-content-num" style="color: #415465">
                    <template v-if="type === 'eb-b'">
                      https://www.imrpress.com/journal/{{journalDetail.name}}/editorial-board
                    </template>
                    <template v-else-if="type === 'rb-b'">
                      https://www.imrpress.com/journal/{{journalDetail.name}}/about/reviewer_board
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import { settingOption } from '@/api/setting'
import journal from '@/api/journal'
import pdfTools from '@/api/pdf_tools'
import operation from '@/api/operation'
import { openJournal } from '@/api/open'
import help from '@/utils/help'
import { saveImage } from '@/utils/pdf'
import cbg from '@/assets/pdf/c-bg'
import bbg from '@/assets/pdf/b-bg'
import sign from '@/assets/pdf/sign'
import pubmed from '@/assets/pdf/pubmed'
import logo from '@/assets/pdf/publish-logo'
import jLogo from '@/assets/pdf/journal-logo'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'eb-c',
      validator(val) {
        return (
          ['eb-c', 'rb-c', 'ge-c', 'rc-c', 'eb-b', 'rb-b', 'ge-b'].indexOf(
            val
          ) !== -1
        )
      },
    },
    journalId: {
      type: String,
      default: '',
    },
    inputData: {
      type: Object,
      default() {
        return {}
      },
    },
    edit: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '',
      params: {
        avatar: '',
        affiliations: [],
      },
      scale: 2,
      rules: {},
      degreesList: [],
      journalDetail: {
        databaseInclusion: [],
      },
      isCropper: false,
      canWidth: 200,
      canHeight: 200,
      chief: {
        JOMH: `<div>Ridwan Shabsigh, MD</div>
        <div>Akira Tsujimura, MD</div>
        <div>Aksam A. Yassin, MD, PhD</div>`,
        FBE: `Baohong Zhang, PhD`,
        FBL: `Graham Pawelec, MD`,
        FBS: `Gustavo Caetano-Anollés, PhD`,
        JIN: `Zhong Chen, Bettina Platt`,
        RCM: `Yujie Zhou, Karol E. Watson`,
        JMCM: `Giuseppe Murdaca, MD, PhD`,
        EJGO: `Enrique Hernandez, MD`,
        CEOG: `Michael H. Dahan, MD`,
        JFSFQ: `Corinna Kehrenberg`,
        MRev: `Simon Jebsen, Guoliang Yang`,
        KO: `Natália Tognoli`,
        JEEMS: `Thomas Steger`,
        IJVNR: `Yuexin Yang, Torsten Bohn`,
        AP: `Francesco Bartoli, Wei Zheng`,
        BP: `Hong Luo, Jose Pedro Espada`,
        RN: `Angela Vidal-Jordana`,
        IJP: `Mehmet Ozaslan`,
        HSF: `Haiyang Li, Giuseppe Santarpino`,
        BJHM: `John Alcolado`,
        DJNB: `Carmen-Georgeta Ristoscu`,
        GHHM: `Xiaokun Li, David W. Bates`,
        Pharmazie: `Walter E. Müller, Hirofumi Takeuchi`,
      },
      cbg,
      bbg,
      sign,
      pubmed,
      logo,
      jLogo,
    }
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {}
        this.rules = {}
      } else {
        switch (this.type) {
          case 'eb-c':
            this.title = 'Generate Editorial Board Member Banner'
            break
          case 'rb-c':
            this.title = 'Generate Reviewer Board Member Certification'
            break
          case 'ge-c':
            this.title = 'Generate Guest Editor Certification'
            break
          case 'rc-c':
            this.title = 'Generate Reviewer Contribution Certification'
            break
          case 'eb-b':
            this.title = 'Generate Editorial Board Member Banner'
            break
          case 'rb-b':
            this.title = 'Generate Reviewer Board Member Banner'
            break
          case 'ge-b':
            this.title = 'Generate Guest Editor Member Banner'
            break
        }
        this.inputData.degreesIdList = this.inputData.degreesList
          ? this.inputData.degreesList.map((item) => {
              return item.name
            })
          : []
        this.params = JSON.parse(JSON.stringify(this.inputData))
        this.getJournal(this.journalId)
        if (['eb-b', 'rb-b', 'ge-b'].includes(this.type)) {
          this.$set(
            this.params,
            'affiliations',
            this.params.affiliation ? this.params.affiliation.split(';') : ['']
          )
          this.getBannerRules()
          this.getDegrees()
          if (this.params.icon) {
            this.getAvatar(this.params.icon)
          }
        } else if (['eb-c', 'rb-c', 'ge-c', 'rc-c'].includes(this.type)) {
          this.getCertificateRules()
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      editorialBoard: 'getEditorialBoard',
      domain: 'getDomain',
    }),
  },
  mounted() {
    help.closeAutocomplete()
  },
  methods: {
    async confirm() {
      const flag = this.$refs['add-pdf-form'].validate()
      if (flag) {
        const el = document.getElementById('showPDFDialog')
        let textInfo = ''
        // this.type.includes('eb-') ? 'EB' : (this.type.includes('rb-') ? 'Reviewer Board' : '')
        if (this.type.includes('eb-')) {
          textInfo = 'EB'
        }
        if (this.type.includes('rb-')) {
          textInfo = 'Reviewer Board'
        }
        if (this.type.includes('rc-')) {
          textInfo = 'Review Contribution'
        }
        saveImage(
          el,
          this.scale,
          `${this.params.firstName} ${this.params.lastName} ${textInfo} ${
            this.type.includes('-b') ? 'Banner' : 'Certification'
          }`
        )
        if (this.type.includes('eb') || this.type.includes('rb')) {
          let authorityCode = '',
            info = ''
          switch (this.type) {
            case 'eb-c':
              authorityCode = 'WEBSITE.EDITOR_BOARD.DOWNLOAD_CERTIFICATE'
              info = 'Editorial Board Certificate'
              break
            case 'eb-b':
              authorityCode = 'WEBSITE.EDITOR_BOARD.DOWNLOAD_BANNER'
              info = 'Editorial Board Banner'
              break
            case 'rb-c':
              authorityCode = 'WEBSITE.REVIEWER_BOARD.DOWNLOAD_CERTIFICATE'
              info = 'Reviewer Board Certificate'
              break
            case 'rb-b':
              authorityCode = 'WEBSITE.REVIEWER_BOARD.DOWNLOAD_BANNER'
              info = 'Reviewer Board Banner'
              break
          }
          await operation.add({
            authorityCode,
            type: 'DOWNLOAD',
            info: `Download ${info}: ${this.params.email}`,
            detail: `【Email】: ${this.params.email}<br/>
          【Name】: ${this.params.firstName} ${this.params.lastName}`,
          })
        }
        this.$emit('confirm', this.params)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async getDegrees(keyword) {
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },
    async getJournal(id) {
      if (this.open) {
        this.journalDetail = await openJournal.query(id)
        return
      }
      this.journalDetail = await journal.query(id)
    },

    cancelCopper() {
      this.isCropper = false
    },
    uploadCropper() {
      this.isCropper = true
    },
    async handleUpload(key, files) {
      const file = files[0]
      const imgFiles = ['icon']
      const imgTypes = ['image/jpeg', 'image/png']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType,
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB',
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/journal/${
          this.inputData.journalId
        }/editorial-board/${key}/${help.guid()}`
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail,
        })
        return false
      }

      this.$set(this.params, key, url)
      this.getAvatar(this.params[key])
    },
    getBannerRules() {
      this.rules = {
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        degreesIdList: [
          {
            required: true,
            message:
              'Degree / Credential' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        affiliation: [
          {
            required: true,
            message: 'Affiliations' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
      }
    },
    getCertificateRules() {
      this.rules = {
        firstName: [
          {
            required: true,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        createTime: [
          {
            required: true,
            message: 'Date' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
      }
    },
    async getAvatar(url) {
      this.$set(
        this.params,
        'avatar',
        await pdfTools.base64(`${this.domain}/${url}`)
      )
    },
    addMore(key) {
      this.params[key].push('')
    },
    delMore(key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore(key) {
      const arr = []
      this.params[key + 's'].forEach((item) => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
  },
}
</script>

<style lang="scss" scoped>
#editorial-borad-pdf {
  .upload-content {
    height: 150px;
    width: 150px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-img {
      height: 150px;
      width: 150px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .showPDFDialog {
    height: 533px;

    #showPDFDialog {
      width: 1980px;
      height: 1332px;
      transform: scale(0.4);
      transform-origin: left top;

      .pdf-content {
        width: 1980px;
        height: 1332px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        padding: 120px 120px 0;
        box-sizing: border-box;

        &-icon {
          // padding: 120px 120px 0 120px;
          width: 100%;
          display: flex;
          box-sizing: border-box;

          img {
            height: 120px;
          }

          > div {
            width: 50%;
          }

          &-r {
            display: flex;

            > div {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 110px;
              height: 110px;
              border: 2px solid #ccc;
              border-radius: 50%;
              margin-left: 20px;
              margin-top: 16px;
              font-size: 18px;

              img {
                width: 90px;
                height: 32px;
              }
            }
          }
        }

        &-editor {
          display: flex;
          padding: 0 80px;
          height: 800px;
          align-items: center;
          justify-content: center;

          &-avatar {
            width: 380px;
            height: 380px;
            border: 12px solid #ccc;
            box-sizing: border-box;
            border-radius: 50%;
            margin: 0 80px;
            overflow: hidden;
            background: #ccd6dd;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          &-detail {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }

        &-title {
          margin-top: 80px;
          font-size: 128px;
          font-family: $h_family;
          text-align: center;
        }

        &-date {
          font-size: 40px;
          font-family: $p_family;
          text-align: center;
        }

        &-name {
          width: 100%;
          height: 104px;
          line-height: 104px;
          text-align: center;
          font-size: 96px;
          margin: 24px auto;
          white-space: nowrap;
          position: relative;
          font-family: $h_family;

          &::after {
            position: absolute;
            content: '';
            width: 900px;
            border-bottom: 1px solid $main_color;
            bottom: -2px;
            left: calc(50% - 450px);
          }
        }

        &-journal {
          text-align: center;
          font-size: 40px;
          line-height: 56px;
        }

        &-num {
          position: absolute;
          left: 120px;
          bottom: 80px;
          font-size: 28px;
        }

        &-chief {
          position: absolute;
          text-align: right;
          right: 120px;
          bottom: 80px;
          font-size: 28px;

          img {
            margin-bottom: -30px;
            // width: 334px;
            height: 84px;
            z-index: 1;
          }

          > div {
            position: relative;
            z-index: 2;
          }
        }
      }
    }
  }

  .svg-logo {
    fill: currentColor;
  }

  .JIN {
    color: #ea762a;
  }

  .JOMH {
    color: #359dd8;
  }

  .FBE {
    color: #5a2e8e;
  }

  .FBL {
    color: #7c180a;
  }

  .FBS {
    color: #3260ad;
  }

  .RCM {
    color: #b7322c;
  }

  .JMCM {
    color: #2da4a6;
  }

  .EJGO {
    color: #5156a5;
  }

  .CEOG {
    color: #b75e83;
  }
}
</style>
